var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras.introduction && _vm.extras.introduction.display == 1)?_c('div',{staticClass:"m-assembly top-nav",style:({
    backgroundColor: _vm.extras.introduction ? _vm.extras.introduction.bg : '#f5f6f7',
  }),attrs:{"id":"introduction"}},[(_vm.extras.introductionTitle && _vm.extras.introductionTitle.display == 1)?_c('WapTitle',{style:({
      color: _vm.extras.introductionTitle ? _vm.extras.introductionTitle.color : '',
      backgroundColor: _vm.extras.introductionTitle
        ? _vm.extras.introductionTitle.bg
        : '',
    }),attrs:{"title":_vm.extras.introductionTitle.introductionTitleVal,"icon":_vm.icon}}):_vm._e(),(_vm.seminarInfo.desc.length == 0)?_c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require('@/assets/images/nodata.png')}}),_c('div',{staticClass:"no-data-text"},[_vm._v("暂无数据")])]):_vm._e(),(
      _vm.extras.introductionDescription &&
      _vm.extras.introductionDescription.display == 1
    )?_c('div',{staticClass:"g-intrd-html",style:({
      color: _vm.extras.introductionDescription
        ? _vm.extras.introductionDescription.color
        : '',
      backgroundColor: _vm.extras.introductionDescription
        ? _vm.extras.introductionDescription.bg
        : '',
    }),domProps:{"innerHTML":_vm._s(_vm.seminarInfo.descWap ? _vm.seminarInfo.descWap : _vm.seminarInfo.desc)}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }